/**
 * Lazy-loads video iframes when the parent accordion is expanded.
 * Observes the collapsible-expandable element's "expanded" attribute
 * and swaps data-src to src on first open.
 * Handles multiple accordion instances (desktop and mobile).
 */
(function() {
  function initLazyVideos() {
    var videoContainers = document.querySelectorAll('.product-accordion-videos');
    if (!videoContainers.length) return;

    videoContainers.forEach(function(container) {
      var iframes = container.querySelectorAll('iframe[data-src]');
      if (!iframes.length) return;

      var accordion = container.closest('collapsible-expandable');
      if (!accordion) return;

      function loadIframes() {
        iframes.forEach(function(iframe) {
          if (!iframe.src && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
          }
        });
      }

      if (accordion.getAttribute('expanded') === 'true') {
        loadIframes();
        return;
      }

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'expanded' && accordion.getAttribute('expanded') === 'true') {
            loadIframes();
            observer.disconnect();
            return;
          }
        }
      });

      observer.observe(accordion, { attributes: true, attributeFilter: ['expanded'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
